/**
 * Pylon help-portal URLs.
 *
 * Known form slugs (sidebar help dropdown):
 *   /forms/submit-a-bug
 *   /forms/feature-request
 *
 * There is no published contact-support form slug. Locked Assistant
 * surfaces therefore open the portal root rather than inventing one
 * (docs/plans/assistant-beta-launch-plan.md Step 2).
 */
export const PYLON_PORTAL_URL = 'https://portal.usepylon.com/fairgen'

/** Support target for every Assistant locked state. Same tab contract: new tab, rel="noopener noreferrer". */
export const PYLON_CONTACT_SUPPORT_URL = PYLON_PORTAL_URL
